import React from 'react'
import { get } from 'lodash'
import { SeparatorWrapper, SeparatorContent, SeparatorText } from './styles'

const Separator = ({ questionObj }) => {
    const marginLeft = get(questionObj, 'properties.marginLeft.value', '30px');
    const spacing = get(questionObj, 'properties.spacing.value', true);
    return (
        <SeparatorWrapper spacing={ spacing }>
            <SeparatorContent spacing={ spacing }>
                <SeparatorText marginLeft={ marginLeft }>{questionObj.question_text}</SeparatorText>
            </SeparatorContent>
        </SeparatorWrapper>
    )
}

export default Separator;
